/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UIConstants from "../../UIConstants";

export default class MandantUtil {
    public static ermittleMandant(pfad: string): string {
        pfad = pfad ?? "";
        const pfadteile = pfad.split("/");
        if (pfadteile.length < 2) {
            return "";
        }

        const mandant = pfadteile[1];
        const mandantRegEx = /^[a-z0-9-]{2,100}$/;

        if (mandant === UIConstants.uiSysPath) {
            return mandant;
        }

        if (mandant.length < 2 || mandant.length > 100 || !mandantRegEx.test(mandant)) {
            return "";
        }

        return mandant;
    }

    public static wechsleMandant(url: string) {
        window.location.replace(`${url}`);
    }
}
